import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { query } from '../graphql'
import { notifyBugsnag } from '../helpers'

export const usePaymentsQuery = ({ partner_id, cognitoUser }) => {
  const [accessDenied, setAccessDenied] = useState(false)
  return {
    accessDenied,
    ...useQuery({
      queryKey: ['payment', partner_id],
      queryFn: async () => {
        const response = await query({
          query: 'paymentByPartnerIdByCreatedAt',
          variables: { partner_id }
        })

        if (!response.length) {
          setAccessDenied(true)

          const message = `no payment found / access denied - username: ${cognitoUser.username} / partner_id: ${partner_id}`
          notifyBugsnag(new Error(message))
          return []
        }

        return response
      },
      enabled: !!partner_id
    })
  }
}
